import React from 'react';

const StorePage = () => {
    return (
        <div style={{ width: '100%', height: '100vh' }}>
            <iframe
                src="https://reflectionsofyoubyamy.com/"
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="Shopify Store"
            />
        </div>
    );
};

export default StorePage;
